import React from 'react';
import { string } from 'prop-types';

// type: string = info | warning | error

function Alert({ heading, description, type }) {
  return (
    <div
      className={`alert ${type ? `alert--${type}` : ''}`}
      role="alert"
      aria-live="polite"
    >
      <div className="alert__wrapper">
        <h3 className="alert__heading">{heading}</h3>
        <p className="alert__description text-base">{description}</p>
      </div>
    </div>
  );
}

Alert.propTypes = {
  heading: string.isRequired,
  description: string.isRequired,
  type: string
};

export default Alert;
